import { CorrectiveProgramInput } from "../../../models/interfaces/corrective-exercises/corrective-program-input";
import { CorrectiveProgramRoutine } from "../../../models/interfaces/corrective-exercises/corrective-program-routine";
import { CorrectiveProgramResult } from "../../../models/interfaces/corrective-exercises/corrective-program-result";
import { ServiceBase } from "../service-base";
import { AdminToolCorrectiveProgramResult } from "../../../models/interfaces/corrective-exercises/admin-tool-corrective-program-result";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface GetCorrectiveProgramRoutineParams {
    programId: string;
    day: number;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint = `/corrective-programs`;
const findProgramEndpoint = `${baseEndpoint}/find-program`;
const findExtraProgramEndpoint = `${baseEndpoint}/find-extra-program`;
const getCorrectiveProgramRoutineEndpoint = `${baseEndpoint}/get-corrective-program-routine`;
const getAdminToolCorrectiveProgramsEndpoint = `${baseEndpoint}/admin-tool-list-programs`;


// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const CorrectiveProgramsService = {
    /**
     * Finds a program matching input
     */
    findProgram: ServiceBase.post<
        CorrectiveProgramResult,
        CorrectiveProgramInput
    >(findProgramEndpoint),

    /**
     * Finds a program matching input
     */
    findExtraProgram: ServiceBase.post<
        CorrectiveProgramResult,
        CorrectiveProgramInput
    >(findExtraProgramEndpoint),

    /**
    * Gets the program routine for a certain day
    */
    getCorrectiveProgramRoutine: ServiceBase.list<
        CorrectiveProgramRoutine,
        GetCorrectiveProgramRoutineParams
    >(getCorrectiveProgramRoutineEndpoint),

    /**
     * Gets corrective programs for admin tool
     */
    getAdminToolCorrectivePrograms: ServiceBase.list<
        AdminToolCorrectiveProgramResult[]>(getAdminToolCorrectiveProgramsEndpoint),

};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default CorrectiveProgramsService;

// #endregion Exports
